import {
  LOAD_LOGIN_LIST,
  LOAD_LOGIN_LIST_SUCCESS,
  LOAD_LOGIN_LIST_ERROR,
  LOAD_LOGIN_DETAILS,
  LOAD_LOGIN_DETAILS_SUCCESS,
  LOAD_LOGIN_DETAILS_ERROR,
  RESET_LOGIN_DETAILS,
  ADD_LOGIN,
  ADD_LOGIN_SUCCESS,
  ADD_LOGIN_ERROR,
  UPDATE_LOGIN,
  UPDATE_LOGIN_SUCCESS,
  UPDATE_LOGIN_ERROR,
  CHANGE_STATUS_LOGIN,
  CHANGE_STATUS_LOGIN_SUCCESS,
  CHANGE_STATUS_LOGIN_ERROR,
  CHANGE_PASSWORD_LOGIN,
  CHANGE_PASSWORD_LOGIN_SUCCESS,
  CHANGE_PASSWORD_LOGIN_ERROR,
  RESET_LOGIN_LIST,
} from '../type';
import update from 'immutability-helper';

import { handleActions } from 'redux-actions';

export const initialState = {
  loadingStatus: {
    loginListLoading: false,
    loginDetailsLoading: false,
    addLoginLoading: false,
    updateLoginLoading: false,
    changeStatusLoginLoading: false,
    changePasswordLoginLoading: false,
  },
  error: '',
  loginList: {},
  loginDetails: {},
};

const loginReducer = handleActions(
  new Map([
    [
      LOAD_LOGIN_LIST,
      state => {
        return update(state, {
          loadingStatus: {
            loginListLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_LOGIN_LIST_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            loginListLoading: { $set: false },
          },
          loginList: {
            data: { $set: action.payload.data },
            offset: { $set: action.payload.offset },
            limit: { $set: action.payload.limit },
            total: { $set: action.payload.total },
          },
        });
      },
    ],
    [
      LOAD_LOGIN_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            loginListLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
    //Reset login list
    [
      RESET_LOGIN_LIST,
      (state, action) => {
        return update(state, {
          loginList: {
            $set: [],
          },
        });
      },
    ],
    [
      LOAD_LOGIN_DETAILS,
      state => {
        return update(state, {
          loadingStatus: {
            loginDetailsLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_LOGIN_DETAILS_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            loginDetailsLoading: { $set: false },
          },
          loginDetails: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      LOAD_LOGIN_DETAILS_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            loginDetailsLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
    [
      RESET_LOGIN_DETAILS,
      (state, action) => {
        return update(state, {
          loginDetails: {
            $set: null,
          },
        });
      },
    ],
    [
      ADD_LOGIN,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            addLoginLoading: { $set: true },
          },
        });
      },
    ],
    [
      ADD_LOGIN_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            addLoginLoading: { $set: false },
          },
          updatedLogin: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      ADD_LOGIN_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            addLoginLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
    [
      UPDATE_LOGIN,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            updateLoginLoading: { $set: true },
          },
        });
      },
    ],
    [
      UPDATE_LOGIN_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            updateLoginLoading: { $set: false },
          },
          updatedLogin: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      UPDATE_LOGIN_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            updateLoginLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
    [
      CHANGE_STATUS_LOGIN,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            changeStatusLoginLoading: { $set: true },
          },
        });
      },
    ],
    [
      CHANGE_STATUS_LOGIN_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            changeStatusLoginLoading: { $set: false },
          },
        });
      },
    ],
    [
      CHANGE_STATUS_LOGIN_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            changeStatusLoginLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
    [
      CHANGE_PASSWORD_LOGIN,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            changePasswordLoginLoading: { $set: true },
          },
        });
      },
    ],
    [
      CHANGE_PASSWORD_LOGIN_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            changePasswordLoginLoading: { $set: false },
          },
        });
      },
    ],
    [
      CHANGE_PASSWORD_LOGIN_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            changePasswordLoginLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
  ]),
  initialState,
);
export default loginReducer;
